// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import GenericListTab from "./../../factories/generic-list-tab";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import SwapEmployees from "./../../factories/shift-schedule-swap-employees-dialog";
import baoMenu from "./../../services/bao-menu";
class ConfigurationItem100ShiftPlan extends GenericListTab {
    Years: number[] = [];
    Months: any[] = [];
    Bao = Bao;
    ConfigurationItem: any;
    SelectedYear: KnockoutObservable<number> = ko.observable(new Date().getFullYear());
    SelectedMonth: KnockoutObservable<any> = ko.observable();
    constructor(tabPage: TabPage, parent?: any) {
        super(tabPage, parent);
        this.ConfigurationItem = parent;
        this.SelectedYear.subscribe(() => {
            this.Refresh();
        });
        this.SelectedMonth.subscribe(() => {
            this.Refresh();
        });
    }
    DialogWidth = 500;
    CustomFilter() {
        //return null;
        var customFilterHashObject = [];
        if (this.SelectedYear() != null) {
            var hashObjectYear: any = {};
            hashObjectYear.Key = 'Year';
            hashObjectYear.Value = this.SelectedYear();
            customFilterHashObject.push(hashObjectYear);
        }
        if (this.SelectedMonth() != null) {
            var hashObjectMonth: any = {};
            hashObjectMonth.Key = 'Month';
            hashObjectMonth.Value = this.SelectedMonth().Key;
            customFilterHashObject.push(hashObjectMonth);
        }
        return customFilterHashObject;
    }
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        var result = true;
        if (item.ShiftTypeName() == null) {
            result = false;
        }
        if (item.ValidToJs() == null) {
            result = false;
        }
        if (!result) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        def.resolve(result);
        return def.promise();
    }
    LoadFilter(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        $.when(Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), (result) => {
            var currentYear = new Date().getFullYear();
            for (var r in result) {
                if (result[r] != null) {
                    this.Years.push(result[r].Key); //Liste mit jahreszahlen erstellen
                }
            }
            this.SelectedYear(currentYear);
        })).then(() => {
            Bao.post("SynosetMasterData/GetMonthCollection", JSON.stringify({}), (result) => {
                var currentMonth = new Date().getMonth() + 1;
                for (var r in result) {
                    if (result[r] != null) {
                        this.Months.push(result[r]); //Liste mit jahreszahlen erstellen
                        if (result[r].Key == currentMonth) {
                            this.SelectedMonth(result[r]);
                        }
                    }
                }
                return def.resolve();
            });
        });
        return def.promise();
    }
    ;
    init() {
        return super.init().then(() => {
            return this.LoadFilter();
        }).then(() => {
            baoMenu.registerEvent((action) => { this.CustomToolbarClick(action); });
        });
    }
    CustomToolbarClick = (action: Interfaces.Bao.BaoMenuItem) => {
        if (this.TabPage.IsActiveTab()) {
            switch (ko.unwrap(action.ActionKey)) {
                case "ConfigurationItem100ShiftPlanTabSwap":
                    if (this.Selection()[0] != null) {
                        this.SwapCurrentSelection();
                    }
                    break;
            }
        }
    };
    SwapCurrentSelection() {
        let dateOfSelection: string = null;
        if (this.Selection() && this.Selection().length > 0) {
            dateOfSelection = this.Selection()[0].ValidToJs;
        }
        let personId = this.GetParentId();
        let personName = this.Parent["FullName"]();
        let swapEmployeesFactory = new SwapEmployees(this.TabPage.IsLoading, personId, null, dateOfSelection, personName);
        swapEmployeesFactory.Dialog().then((dialogResult) => {
            if (dialogResult) {
                return this.Refresh();
            }
        });
    }
    Dialog(id: string): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                var item = dialog.ViewModel();
                delete item.Parent;

                this.ItemCompleteCheck.call(this, item).then((validateResult) => {
                    if (validateResult) {
                        this.Save(ko.map.toJS(item)).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            var vm = ko.map.fromJS(result.Model);
            if (id === undefined || Bao.Utils.String.IsNullOrEmpty(id)) {
                vm.ShiftGroupName(this.TabPage.ViewModel().Parent.ShiftGroupName());
                vm.ShiftGroupId(this.TabPage.ViewModel().Parent.ShiftGroupId());
            } vm.Parent = this;
            dialog.ViewModel(vm);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            let key = ko.unwrap(button.ActionKey);
            let enabled: KnockoutObservable<boolean> = (button.Enabled) as KnockoutObservable<boolean>;
            if (key == "ConfigurationItem100ShiftPlanTabSwap") {
                enabled(this.Selection() != null && this.Selection().length == 1);
            }
        });
    }
    ;
}
export default ConfigurationItem100ShiftPlan;